<div class="mobile-wrapper">
  <div class="content">
    <div class="title-content">
      <div class="ptlFps-title" [ngClass]="{'Text-std': isPantherLakeStd,'Text-gamming12xe':isPantherLakeGaming || isPantherLake12Xe,
    'intelOne-headline': setFontIntelDisplayOne, 'other-lang-font-style': !setFontIntelDisplayOne, 'non-italic-lang-cls' : nonItalicLangArray.includes(language)}" [innerHtml]="ulThreeDMarkData.tr_TileTitle"></div>
      <div class="subtitle"
        [ngClass]="{'Text-std': isPantherLakeStd,'FPS_Gammingtitle': isPantherLakeGaming || isPantherLake12Xe,'intelOne-display': setFontIntelDisplayOne}"
        [innerHtml]="ulThreeDMarkData.tr_subtitle"></div>
      <div class="subdescription"
        [ngClass]="{'Text-std': isPantherLakeStd,'FPS_Gammingtitle': isPantherLakeGaming || isPantherLake12Xe,'intelOne-display': setFontIntelDisplayOne}"
        [innerHtml]="ulThreeDMarkData.tr_description"></div>
    </div>
    <div class="Carosuel-Games-container">
      <div
        [ngClass]="{'intel-strip-12Xe': isPantherLake12Xe,'intel-strip': isPantherLakeGaming || isPantherLakeStd,'intelOne-display': setFontIntelDisplayOne}">
        <div *ngIf="isPantherLakeStd || isPantherLakeGaming">
          <img [src]="ulThreeDMarkData?.badgeUrl" alt="Intel logo" class="intel-logo" />
          <span
            [ngClass]="{'intel-text': isPantherLakeStd,'intel-text-gamming': isPantherLakeGaming,'intelOne-display': setFontIntelDisplayOne}"
            [innerHtml]="ulThreeDMarkData.tr_title"></span>
        </div>
        <div *ngIf="isPantherLake12Xe" class="Xebadges">
          <div class="intelBadge">
            <span><img [src]="ulThreeDMarkData?.badgeUrl" alt="processor badge" class="intel-logo" /></span>
            <span class="processor-seperation"></span>
            <span><img class="intel-logo" src="assets/images/arc-badge.svg" alt="processor logo"></span>
          </div>

          <span class="intel-text-12Xe" [ngClass]="{'intelOne-display':setFontIntelDisplayOne}"
            [innerHTML]="ulThreeDMarkData.tr_title"></span>
        </div>

      </div>
      <div class="carousel-container">
        <div class="carousel-wrapper" (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)">
          <div class="carousel-track">
            <div *ngFor="let item of fpsData; let i = index" class="carousel-card"
              [ngClass]="{'ptl12xe-carousel-card': isPantherLake12Xe, 'gaming-carousel-card': isPantherLakeGaming, 'hidden-card': getCardPosition(i) > 2 || getCardPosition(i) < -2}"
              [attr.data-position]="getCardPosition(i)" (click)="goToSlide(i)">
              <img [src]="item.targetUrl" [alt]="item.game_name" class="card-image">
            </div>
          </div>
        </div>

        <div class="card-info">
          <div class="card-align">
            <div class="static-card"
              [ngClass]="{'ptl12xe-static-card': isPantherLake12Xe, 'gaming-static-card': isPantherLakeGaming}">
              <div class="static-card-content"
                [ngClass]="{'static-card-content-white': (isPantherLake12Xe || isPantherLakeGaming)}">
                <div class="game-title" [ngClass]="{'intelOne-display': setFontIntelDisplayOne}"
                  [innerHTML]="fpsData[currentIndex]?.name"></div>
                <div class="game-info">
                  <div style="display: flex">
                    <div class="fps-display" [ngClass]="{'intelOne-display': setFontIntelDisplayOne}"
                      [innerHTML]="fpsData[currentIndex]?.score"></div>
                    <span id="plusIcon" class="plus-icon">+</span>
                  </div>
                  <div class="game-specs" [ngClass]="{'intelOne-display': setFontIntelDisplayOne}"
                    [innerHTML]="averageScoreText"></div>
                </div>
                <div class="resolution">
                  <div [ngClass]="{'intelOne-display': setFontIntelDisplayOne}" [innerHTML]="fpsSettingText"></div>
                  <div class="inline_separator"
                    [ngClass]="{'inline_separator-white': (isPantherLake12Xe || isPantherLakeGaming)}"></div>
                  <div [ngClass]="{'intelOne-display': setFontIntelDisplayOne}" [innerHTML]="fpsResolution"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="carousel-indicators">
            <span *ngFor="let item of [0,1,2,3,4,5,6]; let i = index" class="indicator" [ngClass]="{
    'indicator_std': isPantherLakeStd,
    'indicator_12Xe_gamming': isPantherLakeGaming || isPantherLake12Xe
  }" [class.active]="i === currentIndex"
              (click)="goToSlide(i)">
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-content">
      <div class="footer" [ngClass]="{'intelOne-display': setFontIntelDisplayOne}">
        <img class="ThreeDMarkLogo" [src]="ulThreeDMarkData?.badgeUrl1" alt="3dMark_logo" />
      </div>
      <div class="footertext"
        [ngClass]="{'Text-std': isPantherLakeStd,'Text-gamming12xe': isPantherLakeGaming || isPantherLake12Xe,'intelOne-display': setFontIntelDisplayOne}"
        (click)="openFPSGamingLegalModal(modalContent)">
        <span class="legal-text-decoration" [innerHTML]="ulThreeDMarkData.tr_tabName"></span>
      </div>
    </div>
  </div>
</div>
<!-- model  -->
<ng-template #modalContent let-modal>
  <div class="modal-header">
    <span class="legal-modaltext" [ngClass]="[setFontIntelDisplayOne ? 'intelOne-display': setFont()]" [innerHtml]="ulThreeDMarkData.tr_legalName"></span>
    <span class="close-body" (click)="closePTLGamingLegalModal()"><img class="close-icon"
        src="assets/images/modal_close_icon.png" alt="close_icon"></span>
  </div>
  <div [ngClass]="[setFontIntelDisplayOne ? 'intelOne-display': setFont()]">
    <p class="modal-body" [innerHTML]="ulThreeDMarkData.tr_notes"></p>
  </div>
</ng-template>